export default __webpack_public_path__ + "static/media/feat-icon2.55b3c9d4.svg";